import _ from "lodash";

export const SubscriptionCardStyle3 = ({ subscription, subscribe }: any) => {
    
    const image = require('../../../assets/img/image 1.png');
    return (
        <>
            <div className="flex flex-col items-center w-full max-w-sm md:max-w-md lg:max-w-lg p-4 border rounded-xl border-gray-600 hover:scale-110 hover:border hover:rounded-xl hover:border-gray-100 hover:shadow-[0px_15px_55px_rgba(34,34,34,0.15)] bg-gray-100">
                <div className="relative w-full">
                    <div className="w-full h-0 pb-[75%] bg-zinc-200 rounded-2xl overflow-hidden"> {/* Aspect ratio of 4:3 */}
                        <img
                            className="absolute inset-0 w-full h-full object-contain rounded-2xl"
                            src={subscription?.MediaMappings?.MediaFiles[0]?.FileMappingURL || image }
                            alt={subscription?.Name || "Subscription Image"}
                        />
                    </div>
                </div>
                <div className="flex flex-col w-full mt-4 px-2">
                    <div className="text-black text-lg md:text-xl font-medium capitalize truncate">
                        {subscription?.Name}
                    </div>
                    <div className="flex items-center justify-between mt-2 text-sm md:text-base">
                        <div className="text-black font-medium">{subscription?.Description}</div>
                    </div>
                    <div className="text-sm font-light text-stone-600 capitalize mt-2 truncate">
                        {subscription?.seller}
                    </div>
                </div>
                <div className="flex flex-col w-full py-2">
                    <button className="bg-blue-500 w-full h-14 flex items-center justify-center text-white" onClick={() => subscribe(subscription)}>
                        <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" className="mr-2">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fill="none" stroke="#ffffff" stroke-width="2" d="M12 5v14m-7-7h14"></path>
                            </g>
                        </svg>
                        Choose Program
                    </button>
                </div>
            </div>     
        </>
    );
};